import { render } from "./PatientTherapies.vue?vue&type=template&id=71587318"
import script from "./PatientTherapies.vue?vue&type=script&lang=js"
export * from "./PatientTherapies.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__